import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Container } from '../../styles/variables';
import PageStyledTitle from '../PageStyledTitle';
import useIntersection from '../useIntersection';
import Project from '../Project';

// Build a design for the work section

const WorkContainer = styled.div`
`;

function Work() {
  const ref = useRef(null);
  const inViewPort = useIntersection(ref, '0px');

  useEffect(() => {
    if (inViewPort) {
      // console.log('Work is in viewport', inViewPort);
    }
  }, [inViewPort]);
  return (
    <Container id="work">
      <WorkContainer>
        <div ref={ref}>
          <PageStyledTitle mClassName="work-title" title="Work" />
          <Project />
        </div>
      </WorkContainer>
    </Container>
  );
}

export default Work;
